type SearchIconProps = {
  color?: string;
  width?: number;
  height?: number;
};

const SearchIcon = ({ color = "white", width = 24, height = 24 }: SearchIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 64 64"
    fill="none"
  >
    <path
      fill={color}
      d="M25.5,0a25.5,25.5,0,1,0,15,46.13l12.7,12.7a4,4,0,0,0,5.66-5.66l-12.7-12.7A25.48,25.48,0,0,0,25.5,0Zm0,43A17.5,17.5,0,1,1,43,25.5,17.52,17.52,0,0,1,25.5,43Z"
    />
  </svg>
);

export default SearchIcon;
